module.exports = __webpack_public_path__ + "img/excel.7e383b81.svg";